import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useWakeLock } from '@/hooks/useWakeLock';

/**
 * ゲスト画面ようこそダイアログ カスタムフック
 */
export const useWelcomeGuestDialog = () => {
  const [isWelcomeGuestDialogOpen, setIsWelcomeGuestDialogOpen] =
    useState<boolean>(true);

  const { addWakeLock } = useWakeLock();
  const { t } = useTranslation();

  /**
   * ゲスト画面ようこそダイアログのOKボタン押下時の処理
   */
  const clickWelcomeGuestOKButton = useCallback(() => {
    setIsWelcomeGuestDialogOpen(false);
    addWakeLock();
  }, [addWakeLock]);

  /**
   * ダイアログのタイトル
   */
  const title = t('welcomeGuestDialog.ポケトークへようこそ').toString();

  return { isWelcomeGuestDialogOpen, clickWelcomeGuestOKButton, title };
};
